import BudgetType from '../../../enums/budget-type';

export interface IBudgetItem {
  id?: number;
  farm_id?: string;
  season_id?: string;
  name: string;
  title: string;
  value: number;
  value_ha: number;
  level?: number;
  parent?: string;
  calculable?: Array<string>;
  children?: IBudget;
  uppercase?: boolean;
  hideBorder?: boolean;
  category_id?: string;
  disabled?: boolean;
}

export interface IBudget {
  [key: string]: IBudgetItem;
}

export const budgetBlueprint: IBudget = {
  [BudgetType.REVENUES_TOTAL]: {
    name: BudgetType.REVENUES_TOTAL,
    level: 1,
    title: 'pages.finance.budget.' + BudgetType.REVENUES_TOTAL,
    value: 0,
    value_ha: 0,
    calculable: [
      BudgetType.REVENUES_CROP,
      BudgetType.REVENUES_ANIMAL,
      BudgetType.REVENUES_STATE_AID,
      BudgetType.REVENUES_OTHER,
    ],
  },
  [BudgetType.REVENUES_CROP]: {
    name: BudgetType.REVENUES_CROP,
    level: 2,
    title: 'pages.finance.budget.' + BudgetType.REVENUES_CROP,
    value: 0,
    value_ha: 0,
  },
  [BudgetType.REVENUES_ANIMAL]: {
    name: BudgetType.REVENUES_ANIMAL,
    level: 2,
    title: 'pages.finance.budget.' + BudgetType.REVENUES_ANIMAL,
    value: 0,
    value_ha: 0,
  },
  [BudgetType.REVENUES_STATE_AID]: {
    name: BudgetType.REVENUES_STATE_AID,
    level: 2,
    title: 'pages.finance.budget.' + BudgetType.REVENUES_STATE_AID,
    value: 0,
    value_ha: 0,
  },
  [BudgetType.REVENUES_OTHER]: {
    name: BudgetType.REVENUES_OTHER,
    level: 2,
    title: 'pages.finance.budget.' + BudgetType.REVENUES_OTHER,
    value: 0,
    value_ha: 0,
  },
  [BudgetType.COSTS_TOTAL]: {
    name: BudgetType.COSTS_TOTAL,
    calculable: [BudgetType.COSTS_CROP, BudgetType.COSTS_ANIMAL],
    level: 1,
    title: 'pages.finance.budget.' + BudgetType.COSTS_TOTAL,
    value: 0,
    value_ha: 0,
  },
  [BudgetType.COSTS_CROP]: {
    name: BudgetType.COSTS_CROP,
    calculable: [
      BudgetType.COSTS_CROP_SEED,
      BudgetType.COSTS_CROP_FERTILIZERS,
      BudgetType.COSTS_CROP_PLANT,
      BudgetType.COSTS_CROP_SERVICES,
      BudgetType.COSTS_CROP_FUEL,
      BudgetType.COSTS_CROP_OTHER,
    ],
    children: {
      [BudgetType.COSTS_CROP_SEED]: {
        name: BudgetType.COSTS_CROP_SEED,
        parent: BudgetType.COSTS_CROP,
        level: 3,
        title: 'pages.finance.budget.' + BudgetType.COSTS_CROP_SEED,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.COSTS_CROP_FERTILIZERS]: {
        name: BudgetType.COSTS_CROP_FERTILIZERS,
        parent: BudgetType.COSTS_CROP,
        level: 3,
        title: 'pages.finance.budget.' + BudgetType.COSTS_CROP_FERTILIZERS,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.COSTS_CROP_PLANT]: {
        name: BudgetType.COSTS_CROP_PLANT,
        parent: BudgetType.COSTS_CROP,
        level: 3,
        title: 'pages.finance.budget.' + BudgetType.COSTS_CROP_PLANT,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.COSTS_CROP_SERVICES]: {
        name: BudgetType.COSTS_CROP_SERVICES,
        parent: BudgetType.COSTS_CROP,
        level: 3,
        title: 'pages.finance.budget.' + BudgetType.COSTS_CROP_SERVICES,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.COSTS_CROP_FUEL]: {
        name: BudgetType.COSTS_CROP_FUEL,
        parent: BudgetType.COSTS_CROP,
        level: 3,
        title: 'pages.finance.budget.' + BudgetType.COSTS_CROP_FUEL,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.COSTS_CROP_OTHER]: {
        name: BudgetType.COSTS_CROP_OTHER,
        parent: BudgetType.COSTS_CROP,
        level: 3,
        title: 'pages.finance.budget.' + BudgetType.COSTS_CROP_OTHER,
        value: 0,
        value_ha: 0,
      },
    },
    level: 2,
    title: 'pages.finance.budget.costs_crop',
    value: 0,
    value_ha: 0,
  },
  [BudgetType.COSTS_ANIMAL]: {
    name: BudgetType.COSTS_ANIMAL,
    calculable: [
      BudgetType.COSTS_ANIMAL_FODDER,
      BudgetType.COSTS_ANIMAL_VETERINARY,
      BudgetType.COSTS_ANIMAL_INSEMINATION,
      BudgetType.COSTS_ANIMAL_ANIMALS,
      BudgetType.COSTS_ANIMAL_MONITORING,
      BudgetType.COSTS_ANIMAL_FUEL,
      BudgetType.COSTS_ANIMAL_OTHER,
    ],
    children: {
      [BudgetType.COSTS_ANIMAL_FODDER]: {
        name: BudgetType.COSTS_ANIMAL_FODDER,
        parent: BudgetType.COSTS_ANIMAL,
        level: 3,
        title: 'pages.finance.budget.' + BudgetType.COSTS_ANIMAL_FODDER,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.COSTS_ANIMAL_VETERINARY]: {
        name: BudgetType.COSTS_ANIMAL_VETERINARY,
        parent: BudgetType.COSTS_ANIMAL,
        level: 3,
        title: 'pages.finance.budget.' + BudgetType.COSTS_ANIMAL_VETERINARY,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.COSTS_ANIMAL_INSEMINATION]: {
        name: BudgetType.COSTS_ANIMAL_INSEMINATION,
        parent: BudgetType.COSTS_ANIMAL,
        level: 3,
        title: 'pages.finance.budget.' + BudgetType.COSTS_ANIMAL_INSEMINATION,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.COSTS_ANIMAL_ANIMALS]: {
        name: BudgetType.COSTS_ANIMAL_ANIMALS,
        parent: BudgetType.COSTS_ANIMAL,
        level: 3,
        title: 'pages.finance.budget.' + BudgetType.COSTS_ANIMAL_ANIMALS,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.COSTS_ANIMAL_MONITORING]: {
        name: BudgetType.COSTS_ANIMAL_MONITORING,
        parent: BudgetType.COSTS_ANIMAL,
        level: 3,
        title: 'pages.finance.budget.' + BudgetType.COSTS_ANIMAL_MONITORING,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.COSTS_ANIMAL_FUEL]: {
        name: BudgetType.COSTS_ANIMAL_FUEL,
        parent: BudgetType.COSTS_ANIMAL,
        level: 3,
        title: 'pages.finance.budget.' + BudgetType.COSTS_ANIMAL_FUEL,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.COSTS_ANIMAL_OTHER]: {
        name: BudgetType.COSTS_ANIMAL_OTHER,
        parent: BudgetType.COSTS_ANIMAL,
        level: 3,
        title: 'pages.finance.budget.' + BudgetType.COSTS_ANIMAL_OTHER,
        value: 0,
        value_ha: 0,
      },
    },
    level: 2,
    title: 'pages.finance.budget.' + BudgetType.COSTS_ANIMAL,
    value: 0,
    value_ha: 0,
  },
  [BudgetType.GROSS_PROFIT]: {
    name: BudgetType.GROSS_PROFIT,
    calculable: [BudgetType.REVENUES_TOTAL, BudgetType.COSTS_TOTAL],
    uppercase: true,
    level: 1,
    title: 'pages.finance.budget.' + BudgetType.GROSS_PROFIT,
    value: 0,
    value_ha: 0,
  },
  [BudgetType.GROSS_PROFITABILITY]: {
    name: BudgetType.GROSS_PROFITABILITY,
    calculable: [
      BudgetType.REVENUES_TOTAL,
      BudgetType.COSTS_TOTAL,
      BudgetType.REVENUES_TOTAL,
    ],
    uppercase: true,
    level: 1,
    title: 'pages.finance.budget.' + BudgetType.GROSS_PROFITABILITY,
    value: 0,
    value_ha: 0,
  },
  [BudgetType.TOTAL_PRODUCTION_COSTS]: {
    name: BudgetType.TOTAL_PRODUCTION_COSTS,
    calculable: [
      BudgetType.TOTAL_PRODUCTION_COSTS_FUEL,
      BudgetType.TOTAL_PRODUCTION_COSTS_ELECTRICITY,
      BudgetType.TOTAL_PRODUCTION_COSTS_UTILITIES,
      BudgetType.TOTAL_PRODUCTION_COSTS_SALARY,
      BudgetType.TOTAL_PRODUCTION_COSTS_TAXES,
      BudgetType.TOTAL_PRODUCTION_COSTS_ADMINISTRATION,
      BudgetType.TOTAL_PRODUCTION_COSTS_INSURANCE,
      BudgetType.TOTAL_PRODUCTION_COSTS_TRANSPORT,
      BudgetType.TOTAL_PRODUCTION_COSTS_RENT,
      BudgetType.TOTAL_PRODUCTION_COSTS_EQUIPMENT,
      BudgetType.TOTAL_PRODUCTION_COSTS_BUILDING_REPAIR,
      BudgetType.TOTAL_PRODUCTION_COSTS_OTHER,
    ],
    children: {
      [BudgetType.TOTAL_PRODUCTION_COSTS_FUEL]: {
        name: BudgetType.TOTAL_PRODUCTION_COSTS_FUEL,
        parent: BudgetType.TOTAL_PRODUCTION_COSTS,
        level: 3,
        title: 'pages.finance.budget.' + BudgetType.TOTAL_PRODUCTION_COSTS_FUEL,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.TOTAL_PRODUCTION_COSTS_ELECTRICITY]: {
        name: BudgetType.TOTAL_PRODUCTION_COSTS_ELECTRICITY,
        parent: BudgetType.TOTAL_PRODUCTION_COSTS,
        level: 3,
        title:
          'pages.finance.budget.' +
          BudgetType.TOTAL_PRODUCTION_COSTS_ELECTRICITY,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.TOTAL_PRODUCTION_COSTS_UTILITIES]: {
        name: BudgetType.TOTAL_PRODUCTION_COSTS_UTILITIES,
        parent: BudgetType.TOTAL_PRODUCTION_COSTS,
        level: 3,
        title:
          'pages.finance.budget.' + BudgetType.TOTAL_PRODUCTION_COSTS_UTILITIES,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.TOTAL_PRODUCTION_COSTS_SALARY]: {
        name: BudgetType.TOTAL_PRODUCTION_COSTS_SALARY,
        parent: BudgetType.TOTAL_PRODUCTION_COSTS,
        level: 3,
        title:
          'pages.finance.budget.' + BudgetType.TOTAL_PRODUCTION_COSTS_SALARY,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.TOTAL_PRODUCTION_COSTS_TAXES]: {
        name: BudgetType.TOTAL_PRODUCTION_COSTS_TAXES,
        parent: BudgetType.TOTAL_PRODUCTION_COSTS,
        level: 3,
        title:
          'pages.finance.budget.' + BudgetType.TOTAL_PRODUCTION_COSTS_TAXES,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.TOTAL_PRODUCTION_COSTS_ADMINISTRATION]: {
        name: BudgetType.TOTAL_PRODUCTION_COSTS_ADMINISTRATION,
        parent: BudgetType.TOTAL_PRODUCTION_COSTS,
        level: 3,
        title:
          'pages.finance.budget.' +
          BudgetType.TOTAL_PRODUCTION_COSTS_ADMINISTRATION,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.TOTAL_PRODUCTION_COSTS_INSURANCE]: {
        name: BudgetType.TOTAL_PRODUCTION_COSTS_INSURANCE,
        parent: BudgetType.TOTAL_PRODUCTION_COSTS,
        level: 3,
        title:
          'pages.finance.budget.' + BudgetType.TOTAL_PRODUCTION_COSTS_INSURANCE,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.TOTAL_PRODUCTION_COSTS_TRANSPORT]: {
        name: BudgetType.TOTAL_PRODUCTION_COSTS_TRANSPORT,
        parent: BudgetType.TOTAL_PRODUCTION_COSTS,
        level: 3,
        title:
          'pages.finance.budget.' + BudgetType.TOTAL_PRODUCTION_COSTS_TRANSPORT,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.TOTAL_PRODUCTION_COSTS_RENT]: {
        name: BudgetType.TOTAL_PRODUCTION_COSTS_RENT,
        parent: BudgetType.TOTAL_PRODUCTION_COSTS,
        level: 3,
        title: 'pages.finance.budget.' + BudgetType.TOTAL_PRODUCTION_COSTS_RENT,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.TOTAL_PRODUCTION_COSTS_EQUIPMENT]: {
        name: BudgetType.TOTAL_PRODUCTION_COSTS_EQUIPMENT,
        parent: BudgetType.TOTAL_PRODUCTION_COSTS,
        level: 3,
        title:
          'pages.finance.budget.' + BudgetType.TOTAL_PRODUCTION_COSTS_EQUIPMENT,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.TOTAL_PRODUCTION_COSTS_BUILDING_REPAIR]: {
        name: BudgetType.TOTAL_PRODUCTION_COSTS_BUILDING_REPAIR,
        parent: BudgetType.TOTAL_PRODUCTION_COSTS,
        level: 3,
        title:
          'pages.finance.budget.' +
          BudgetType.TOTAL_PRODUCTION_COSTS_BUILDING_REPAIR,
        value: 0,
        value_ha: 0,
      },
      [BudgetType.TOTAL_PRODUCTION_COSTS_OTHER]: {
        name: BudgetType.TOTAL_PRODUCTION_COSTS_OTHER,
        parent: BudgetType.TOTAL_PRODUCTION_COSTS,
        level: 3,
        title:
          'pages.finance.budget.' + BudgetType.TOTAL_PRODUCTION_COSTS_OTHER,
        value: 0,
        value_ha: 0,
      },
    },
    level: 1,
    title: 'pages.finance.budget.' + BudgetType.TOTAL_PRODUCTION_COSTS,
    value: 0,
    value_ha: 0,
  },
  [BudgetType.EBITDA]: {
    name: BudgetType.EBITDA,
    calculable: [BudgetType.GROSS_PROFIT, BudgetType.TOTAL_PRODUCTION_COSTS],
    uppercase: true,
    level: 1,
    title: 'pages.finance.budget.' + BudgetType.EBITDA,
    value: 0,
    value_ha: 0,
  },
  [BudgetType.EQUIPMENT]: {
    name: BudgetType.EQUIPMENT,
    level: 2,
    title: 'pages.finance.budget.' + BudgetType.EQUIPMENT,
    value: 0,
    value_ha: 0,
  },
  [BudgetType.BUILDINGS]: {
    name: BudgetType.BUILDINGS,
    level: 2,
    title: 'pages.finance.budget.' + BudgetType.BUILDINGS,
    value: 0,
    value_ha: 0,
  },
  [BudgetType.EBIT]: {
    name: BudgetType.EBIT,
    calculable: [
      BudgetType.GROSS_PROFIT,
      BudgetType.TOTAL_PRODUCTION_COSTS,
      BudgetType.EQUIPMENT,
      BudgetType.BUILDINGS,
    ],
    uppercase: true,
    level: 1,
    title: 'pages.finance.budget.' + BudgetType.EBIT,
    value: 0,
    value_ha: 0,
  },
  [BudgetType.LOAN_PAYMENTS]: {
    name: BudgetType.LOAN_PAYMENTS,
    level: 2,
    title: 'pages.finance.budget.' + BudgetType.LOAN_PAYMENTS,
    value: 0,
    value_ha: 0,
  },
  [BudgetType.NET_PROFIT]: {
    name: BudgetType.NET_PROFIT,
    calculable: [BudgetType.EBIT, BudgetType.LOAN_PAYMENTS],
    uppercase: true,
    level: 1,
    title: 'pages.finance.budget.' + BudgetType.NET_PROFIT,
    value: 0,
    value_ha: 0,
  },
  [BudgetType.WITHOUT_AREA_PAYMENTS]: {
    name: BudgetType.WITHOUT_AREA_PAYMENTS,
    calculable: [BudgetType.NET_PROFIT, 'revenues_stateAid'],
    level: 1,
    title: 'pages.finance.budget.without_area_payments',
    value: 0,
    value_ha: 0,
  },
  [BudgetType.TDS]: {
    name: BudgetType.TDS,
    level: 2,
    title: 'pages.finance.budget.' + BudgetType.TDS,
    value: 0,
    value_ha: 0,
  },
  [BudgetType.DSCR]: {
    name: BudgetType.DSCR,
    calculable: [BudgetType.EBITDA, BudgetType.TDS],
    hideBorder: true,
    level: 1,
    title: 'pages.finance.budget.' + BudgetType.DSCR,
    value: 0,
    value_ha: 0,
  },
};
